import React from 'react';
import { motion } from 'framer-motion';
import { Gamepad2, CreditCard, Clock, Frown, BookX, PiggyBank, MonitorOff, MessageSquareX } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <CreditCard className="w-6 h-6 text-orange" data-id="element-140" />,
    text: 'Tu hijo cree que el dinero sale mágicamente de una tarjeta de crédito.'
  }, {
    icon: <Clock className="w-6 h-6 text-orange" data-id="element-141" />,
    text: 'El tiempo frente a la pantalla aumenta, pero su confianza social disminuye.'
  }, {
    icon: <Frown className="w-6 h-6 text-orange" data-id="element-142" />,
    text: "La 'mesada' semanal les enseña a esperar un pago por existir, no por aportar valor."
  }, {
    icon: <Gamepad2 className="w-6 h-6 text-orange" data-id="element-143" />,
    text: "Sientes la culpa de decir 'no', pero sabes que regalárselo todo les está haciendo daño a largo plazo."
  }];
  const failures = [{
    icon: <BookX className="w-6 h-6 text-navy" data-id="element-144" />,
    text: 'Los libros de economía para niños son demasiado teóricos y terminan en el estante.'
  }, {
    icon: <PiggyBank className="w-6 h-6 text-navy" data-id="element-145" />,
    text: 'Intentar que ahorren dinero que tú les regalaste no enseña el esfuerzo de ganarlo.'
  }, {
    icon: <MonitorOff className="w-6 h-6 text-navy" data-id="element-146" />,
    text: "Las ideas de negocios 'digitales' son demasiado complejas y terminan frustrando al niño (y dándote más trabajo a ti)."
  }, {
    icon: <MessageSquareX className="w-6 h-6 text-navy" data-id="element-147" />,
    text: "Las charlas sobre el 'valor del dinero' entran por un oído y salen por el otro porque no hay una experiencia real de por medio."
  }];
  return <section className="py-20 md:py-32 bg-gray-light px-4" data-id="element-148">
      <div className="max-w-4xl mx-auto" data-id="element-149">
        {/* Hook */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-150">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-6" data-id="element-151">
            ¿Estás cansado de escuchar el eterno{' '}
            <span className="text-orange italic" data-id="element-152">
              "Papá, ¿me das dinero para Roblox/Fortnite?"
            </span>{' '}
            mientras ves a tu hijo pegado al iPad todo el día?
          </h2>
          <p className="text-lg md:text-xl text-gray-600 font-body leading-relaxed" data-id="element-153">
            Como padres, queremos darles lo que no tuvimos, pero el mayor regalo
            no es el dinero en su mano, sino la capacidad de generarlo por sí
            mismos. Existe un momento mágico donde un niño deja de pedir y
            empieza a crear. Ese momento se llama{' '}
            <strong data-id="element-154">"El Despertar del Mini-CEO"</strong>.
          </p>
        </motion.div>

        {/* The Problem */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-lg border border-gray-200 mb-16" data-id="element-155">
          <h3 className="text-2xl md:text-3xl font-heading font-bold text-navy mb-4 text-center" data-id="element-156">
            El sistema escolar no enseña finanzas
          </h3>
          <p className="text-center text-gray-600 mb-10 font-body" data-id="element-157">
            Y la mayoría de los cursos para niños son aburridos libros de texto
            que nunca se aplican. Mientras tanto:
          </p>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-158">
            {problems.map((prob, idx) => <div key={idx} className="flex items-start gap-4 p-4 bg-orange/5 rounded-xl border border-orange/10" data-id="element-159">
                <div className="flex-shrink-0 mt-1" data-id="element-160">{prob.icon}</div>
                <p className="font-body text-gray-dark font-medium" data-id="element-161">
                  {prob.text}
                </p>
              </div>)}
          </div>
        </motion.div>

        {/* Why what you tried didn't work */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-162">
          <h3 className="text-2xl md:text-3xl font-heading font-bold text-navy mb-10 text-center" data-id="element-163">
            Por qué lo que has intentado no ha funcionado
          </h3>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-164">
            {failures.map((fail, idx) => <div key={idx} className="flex items-start gap-4 p-6 bg-white rounded-xl shadow-sm border border-gray-200" data-id="element-165">
                <div className="flex-shrink-0 mt-1 bg-navy/5 p-2 rounded-lg" data-id="element-166">
                  {fail.icon}
                </div>
                <p className="font-body text-gray-600" data-id="element-167">{fail.text}</p>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}